import React, { useState, useEffect } from 'react'
import { getProxies, SavedProxy } from '../../helpers/proxyStorage'
import Modal from '../Modal/Modal'
import { Header } from '../ui'
import {
	ProxyList,
	ProxyItem,
	ProxyInfo,
	ProxyName,
	ProxyAddress,
	SelectButton,
	EmptyState,
	SearchInput
} from './styles'

interface ProxySelectModalProps {
	isOpen: boolean
	onClose: () => void
	onSelect: (proxy: string) => void
}

const ProxySelectModal: React.FC<ProxySelectModalProps> = ({
	isOpen,
	onClose,
	onSelect
}) => {
	const [proxies, setProxies] = useState<SavedProxy[]>([])
	const [searchTerm, setSearchTerm] = useState('')

	useEffect(() => {
		if (isOpen) {
			const savedProxies = getProxies()
			setProxies(savedProxies)
		}
	}, [isOpen])

	const filteredProxies = proxies.filter(proxy =>
		proxy.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
		proxy.proxy.toLowerCase().includes(searchTerm.toLowerCase())
	)

	const handleSelect = (proxy: string) => {
		onSelect(proxy)
		onClose()
	}

	if (!isOpen) return null

	return (
		<Modal close={onClose}>
			<Header>Select Saved Proxy</Header>
			
			{proxies.length > 0 && (
				<SearchInput
					id='proxy-search'
					type='text'
					placeholder='Search proxies...'
					value={searchTerm}
					onChange={(e) => setSearchTerm(e.target.value)}
				/>
			)}

			{filteredProxies.length === 0 ? (
				<EmptyState>
					{proxies.length === 0 
						? 'No saved proxies found. Save a proxy first to see it here.'
						: 'No proxies match your search.'
					}
				</EmptyState>
			) : (
				<ProxyList>
					{filteredProxies.map((proxy) => (
						<ProxyItem key={proxy.id}>
							<ProxyInfo>
								<ProxyName>{proxy.name}</ProxyName>
								<ProxyAddress>{proxy.proxy}</ProxyAddress>
							</ProxyInfo>
							<SelectButton type="button" onClick={() => handleSelect(proxy.proxy)}>
								Select
							</SelectButton>
						</ProxyItem>
					))}
				</ProxyList>
			)}
		</Modal>
	)
}

export default ProxySelectModal